import React from 'react'
import DeliveryContainer from '../../../../../Components/UserPart/UserList/DeliveryContainer/DeliveryContainer'
import Layout from '../../../Layout'

const Delivery = () => {
  return (
    <Layout>
        <DeliveryContainer/>
    </Layout>
  )
}

export default Delivery